import { checkAuthMemberLifeTime } from "@/helpers/authenticate";

export default async function memberLogin({ to, next }) {
  if (checkAuthMemberLifeTime()) next({ name: "MemberEdit" });
  else next();
}
